import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import Newblock from "./Newblock";
import Box from "@mui/material/Box";
import "./allblock.css";
import { useLocation, Link } from "react-router-dom";

function AllBlock() {
  const location = useLocation()
  return (
    <Box>
      <Navbar />
      <section className="term-detail-page">
        <div className="container">
          <div className="term-detail-header">
            <div className="term-detail-crumb">
              <Link to="/">HOME</Link>
              <span>/</span>
              <span className="term-detail-crumb-active">BLOCKS</span>
            </div>
            <div className="term-detail-title-row">
              <h1 className="term-detail-title">▸ BLOCKS</h1>
            </div>
          </div>
          <Newblock pecuscanData={location.state} />
        </div>
      </section>
      <Footer />
    </Box>
  );
}
export default AllBlock;